/**
 * Generated by Orval
 * Do not edit manually.
 */
import type {
  GetArticleV1200,
  GetKioskRetailCampaignsV1200,
  GetScenariosV1200Item,
  GetScenariosV2200Item,
  PostArticleRecommendationsV1200Item,
  PostArticleRecommendationsV1Body,
  PostDiegoV1200,
  PostDiegoV1Body,
  PostStoryblokV3CdnGet200,
  PostStoryblokV3CdnGetBody,
  PostTokensReplaceV1200,
  PostTokensReplaceV1Body,
} from '../index.schemas.ts';

import { apiFetch } from '../../../utils/fetch.ts';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Get article feed by title and id
 * @summary Get article V1
 */
export const getArticleV1 = (
  title: string,
  shortId: string,
  options?: SecondParameter<typeof apiFetch<GetArticleV1200>>,
) => {
  return apiFetch<GetArticleV1200>({ url: `/front-office/v1/article/${title}/${shortId}`, method: 'GET' }, options);
};
/**
 * Get article recommendations based on title and id
 * @summary Article recommendations V1
 */
export const postArticleRecommendationsV1 = (
  postArticleRecommendationsV1Body?: PostArticleRecommendationsV1Body,
  options?: SecondParameter<typeof apiFetch<PostArticleRecommendationsV1200Item[]>>,
) => {
  return apiFetch<PostArticleRecommendationsV1200Item[]>(
    {
      url: `/front-office/v1/articles/recommendations`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: postArticleRecommendationsV1Body,
    },
    options,
  );
};
/**
 * Retrieve data through the DNX Diego API
 * @summary Diego V1
 */
export const postDiegoV1 = (
  postDiegoV1Body?: PostDiegoV1Body,
  options?: SecondParameter<typeof apiFetch<PostDiegoV1200>>,
) => {
  return apiFetch<PostDiegoV1200>(
    {
      url: `/front-office/v1/diego`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: postDiegoV1Body,
    },
    options,
  );
};
/**
 * Get kiosk retail campaign for given slug
 * @summary Kiosk retail campaigns V1
 */
export const getKioskRetailCampaignsV1 = (
  slug: string,
  options?: SecondParameter<typeof apiFetch<GetKioskRetailCampaignsV1200>>,
) => {
  return apiFetch<GetKioskRetailCampaignsV1200>(
    { url: `/front-office/v1/kiosk/retail-campaigns/${slug}`, method: 'GET' },
    options,
  );
};
/**
 * Replace tokens in the given input using given context
 * @summary Tokens replace V1
 */
export const postTokensReplaceV1 = (
  postTokensReplaceV1Body?: PostTokensReplaceV1Body,
  options?: SecondParameter<typeof apiFetch<PostTokensReplaceV1200>>,
) => {
  return apiFetch<PostTokensReplaceV1200>(
    {
      url: `/front-office/v1/tokens/replace`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: postTokensReplaceV1Body,
    },
    options,
  );
};
/**
 * Get all available scenarios
 * @summary Get scenarios V1
 */
export const getScenariosV1 = (options?: SecondParameter<typeof apiFetch<GetScenariosV1200Item[]>>) => {
  return apiFetch<GetScenariosV1200Item[]>({ url: `/front-office/v1/scenarios`, method: 'GET' }, options);
};
/**
 * Get all available scenarios in the account/subscriptions response shape
 * @summary Get scenarios V2
 */
export const getScenariosV2 = (options?: SecondParameter<typeof apiFetch<GetScenariosV2200Item[]>>) => {
  return apiFetch<GetScenariosV2200Item[]>({ url: `/front-office/v2/scenarios`, method: 'GET' }, options);
};
/**
 * Perform GET requests on the Storyblok CDN API
 * @summary Storyblok V3 - CDN - GET
 */
export const postStoryblokV3CdnGet = (
  path: string,
  postStoryblokV3CdnGetBody?: PostStoryblokV3CdnGetBody,
  options?: SecondParameter<typeof apiFetch<PostStoryblokV3CdnGet200>>,
) => {
  return apiFetch<PostStoryblokV3CdnGet200>(
    {
      url: `/front-office/v3/storyblok/cdn/get/${path}`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: postStoryblokV3CdnGetBody,
    },
    options,
  );
};
export type GetArticleV1Result = NonNullable<Awaited<ReturnType<typeof getArticleV1>>>;
export type PostArticleRecommendationsV1Result = NonNullable<Awaited<ReturnType<typeof postArticleRecommendationsV1>>>;
export type PostDiegoV1Result = NonNullable<Awaited<ReturnType<typeof postDiegoV1>>>;
export type GetKioskRetailCampaignsV1Result = NonNullable<Awaited<ReturnType<typeof getKioskRetailCampaignsV1>>>;
export type PostTokensReplaceV1Result = NonNullable<Awaited<ReturnType<typeof postTokensReplaceV1>>>;
export type GetScenariosV1Result = NonNullable<Awaited<ReturnType<typeof getScenariosV1>>>;
export type GetScenariosV2Result = NonNullable<Awaited<ReturnType<typeof getScenariosV2>>>;
export type PostStoryblokV3CdnGetResult = NonNullable<Awaited<ReturnType<typeof postStoryblokV3CdnGet>>>;
